module.exports = __webpack_public_path__ + "media/images/no_image-7a5d627100699d91bf2f3b24bebd8d9d.gif";